import { HeaderContainer } from '@components/Header/styles';
import logo02ponto1 from '@assets/logo-02-1.svg';
import logo from '@assets/logo.svg';
import { SocialMediaButton } from '@components/SocialMediaButton';
import { useTheme } from 'styled-components';
import {
  CaretDown,
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  UserCircle,
  YoutubeLogo,
} from '@phosphor-icons/react';
import { useMediaQuery } from '@mui/material';

const socialMedias = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/bbmnet',
    icon: <FacebookLogo />,
    color: 'primary',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/bbmnet-licitacoes',
    icon: <LinkedinLogo />,
    color: 'primary',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/bbm_net/',
    icon: <InstagramLogo />,
    color: 'primary',
  },
  {
    name: 'Youtube',
    url: 'https://www.youtube.com/channel/UCVpPOVXilOB6Etk-_uXIZ_Q',
    icon: <YoutubeLogo />,
    color: 'primary',
  },
];

export const Header = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  return (
    <HeaderContainer>
      {isSmallScreen ? (
        <div className='header__logo'>
          <img className="logo" src={logo02ponto1} alt="" width={200} />
          <div className='header__powered_mobile'>
            <p className='header__powered-text'>Powered by:</p>
            <img className="logo" src={logo} alt="Logo da BBM" width={167} />
          </div>
        </div>
      ) : (
        <>
          <a href="https://novobbmnet.com.br">
            <img className="logo" src={logo02ponto1} alt="" width={354} />
          </a>

          <div className='header__powered'>
            <p className='header__powered-text'>Powered by:</p>
            <img className="logo" src={logo} alt="Logo da BBM" width={167} />
          </div>

          {/* Por que tem este input? */}
          {/* <input type="text" /> */}

          <div className="social-media-icons">
            {socialMedias.map(({ name, url, color, icon }) => (
              <SocialMediaButton
                key={name}
                color={theme[color]}
                name={name}
                url={url}
              >
                {icon}
              </SocialMediaButton>
            ))}
          </div>

          {/* Botão de Login, atualmente sem funcionalidade */}
          {/* <button
            className="login-button"
            style={{
              backgroundColor: '#ffffff',
              borderStyle: 'solid',
              borderColor: '#014B9A',
              borderWidth: '2px',
              padding: '0.5em',
              borderRadius: '4px',
            }}
          >
            <UserCircle weight="fill" color={theme.primary} size={24} />

            <span>Entrar</span>

            <CaretDown />
          </button> */}
        </>
      )}
    </HeaderContainer>
  );
};
